import React from "react";
import "./PapayaParking.scss"
const PapayaParking = () => {
    return (
        <div className="PapayaParking">
            PapayaParking
        </div>
    )
}
export default PapayaParking